import { sectionTitleSlideV2 } from '../../../../../slides/shared/section-title-slide-v2';

export const campaignAnalyticsTitleSlideV2 = () =>
  sectionTitleSlideV2('Campaign Analytics');
